import orderConfig from 'emun.order/order.config';
import basicController from "servicestack/basic.controller.properties";
import AutoQuery from "servicestack/auto-query/auto-query";
import "emun.vendor/picker/shipmethod-picker-table.htm";
//import customerConfig from "emun.customer/customer.config";
import VendorParser from "emun.vendor/parser/vendor-parser";
//import ApplyTagsPrompt from "emun.customer/picker/apply-retailer-tags-prompt";

//export const filters = customerConfig.filters;

export const views = {
	list: "table",
	//  cards: "th-large"
};

export default class ShipMethodPickerController {
	constructor(options) {
		const $ctrl = this;
		basicController($ctrl);
		$ctrl.selected = {};
		Object.assign($ctrl, options);
		$ctrl.setShipMethods();
		$ctrl.query = new AutoQuery($ctrl.getAutoQueryOptions());
		$ctrl.bus = $ctrl.query.bus;
		//$ctrl.viewSelectionsChanged(); //load()
	}

	templateUrl = () => `shipmethod-picker-${this.query.view}.htm`;

	selectAll() {
		const $ctrl = this;
		$ctrl.query.results.forEach(p => ($ctrl.selected[p.id] = true));
		this.setShipMethods();
	}
	clearAll() {
		this.selected = {};
		this.setShipMethods();
	}
	canClear() {
		return Object.keys(this.selected).length;
	}

	isSelected(shipmethod) {
		return !!this.selected[shipmethod.id];
	}

	setShipMethods() {
		this.shipmethods = Object.keys(this.selected || {});
	}

	selectionsLabel() {
		const { shipmethods: keys = [] } = this;
		if (keys.length > 4)
			return `Selected: ${keys.slice(0, 4).join(", ")} and ${keys.length -
				4} more...`;
		if (keys.length > 0) return `Selected: ${keys.slice(0, 4).join(", ")}`;
		return "No selections";
	}

	hasSelections = () => Object.keys(this.selected).length > 0;

	viewSelectionsChanged() {
		const $ctrl = this;
		const idIn = $ctrl.viewSelections
			? Object.keys($ctrl.selected || {}).join(",")
			: null;
		$ctrl.query.clearRefinements(false);
		$ctrl.query.filter("IdIn", idIn);
	}

	toggle(shipmethod) {
		const $ctrl = this;
		console.log("toggle", shipmethod.id, $ctrl.selected, shipmethod);

		if ($ctrl.single) {
			$ctrl.$close(shipmethod);
		} else if (shipmethod.id in $ctrl.selected) {
			delete $ctrl.selected[shipmethod.id];
			$ctrl.onShipMethodUnSelected &&
				$ctrl.onShipMethodUnSelected({ $shipmethod: shipmethod, ...$ctrl });
		} else {
			$ctrl.selected[shipmethod.id] = true;
			$ctrl.onShipMethodSelected &&
				$ctrl.onShipMethodSelected({ $shipmethod: shipmethod, ...$ctrl });
		}
		this.setShipMethods();
	}
	select(shipmethod) {
		const $ctrl = this;
		$ctrl.$close([shipmethod]);
	}

	$onDestroy() {
		this.query.dispose();
	}

	// parseVendors() {
	// 	const $ctrl = this;
	// 	VendorParser({}).then(vendorIds => {
	// 		$ctrl.selected = {};
	// 		vendorIds.forEach(vendorId => {
	// 			$ctrl.toggle({ id: vendorId });
	// 		});
	// 		$ctrl.viewSelections = true;
	// 		$ctrl.viewSelectionsChanged();
	// 	});
	// }

	getAutoQueryOptions() {
		const $ctrl = this;
		return {
			url: "QueryShippingMethods.json",
			pageSize: $ctrl.$pageConfig.is("gt-sm") ? 12 : 6,
			views,
			criteria: $ctrl.criteria,
			view: "table",
//			filters,
			// sortOptions: {
			// 	"GroupName": "Name",
			// 	"-GroupName": "Name"
			// },
			hideLeftNav: true, // $ctrl.$pageConfig.is('gt-sm'),
			//orderBy: "GroupName",
			autoLoad: true,
			append: false
		};
	}
}


